/**
 * Created By Henal Khianra
 * Created at 06/03/2020
 * Used for Tablet and mobile screen when multiple columns display in tables
 */

import React from 'react';
import PropTypes from 'prop-types';
import range from 'ramda/src/range';
import cx from 'classnames';
import Icon from '@components/@core/Icon';

const ToggleColumnMenu = (props) => {
    const { column, onVisible, activeTab, className, total } = props;
    const stateArray = range(0, total);
    return (
        <div className={cx('d-flex justify-content-end', activeTab, className)}>
            <span className={cx('pr-4', column == 1 && 'disabled')} onClick={() => onVisible(column - 1)}>
                <Icon name="fas fa-chevron-left" size={16} color="#000" />
            </span>
            {stateArray.map((item, index) => (
                <span className={cx('custom-round me-2', column == index + 1 && 'custom-round-active', index >= 2 && 'd-md-none')} onClick={() => onVisible(index + 1)} key={index} />
            ))}
            <span className={cx('pl-3', total === column && 'disabled')} onClick={() => onVisible(column + 1)}>
                <Icon name="fas fa-chevron-right" size={16} color="#000" />
            </span>
        </div>
    );
};

ToggleColumnMenu.propTypes = {
    column: PropTypes.number,
    activeTab: PropTypes.string,
    className: PropTypes.string,
    total: PropTypes.number,
    onVisible: PropTypes.func,
};

ToggleColumnMenu.defaultProps = {
    column: 1,
    activeTab: '',
    className: '',
    total: 2,
    onVisible: () => {},
};

export default ToggleColumnMenu;
